import Support from './Support';

export default Support;



// WEBPACK FOOTER //
// ./src/pages/static/Support/index.jsx